/* list.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var _33 = "._1e0crqpp{display:var(--_1a5yx7a)}";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import theme from "../theme";

// eslint-disable-next-line @typescript-eslint/no-empty-function
var _32 = "._1di61emw:active{background-color:rgba(203,166,247,.6)}";
var _31 = "._1hvw1o36:focus{outline-width:medium}";
var _30 = "._49pcglyw:focus{outline-style:none}";
var _29 = "._nt751r31:focus{outline-color:currentColor}";
var _28 = "._d0altlke:hover{cursor:pointer}";
var _27 = "._30l35y2n:hover{color:#cdd6f4}";
var _26 = "._irr31wye:hover{background-color:rgba(203,166,247,.4)}";
var _25 = "._w41414jc+._w41414jc{border-top:1px solid rgba(203,166,247,.2)}";
var _24 = "._1bsb1osq{width:100%}";
var _23 = "._v5641y8x{transition:background .3s}";
var _22 = "._1p1dangw{text-transform:uppercase}";
var _21 = "._y3gn1e5h{text-align:left}";
var _20 = "._19bvnm8a{padding-left:var(--_1hdy39e)}";
var _19 = "._19bvf6fq{padding-left:18px}";
var _18 = "._n3tdi2wt{padding-bottom:6px}";
var _17 = "._u5f3f6fq{padding-right:18px}";
var _16 = "._ca0qi2wt{padding-top:6px}";
var _15 = "._tzy4139p{opacity:var(--_yl51qy)}";
var _14 = "._1ul913i4{min-width:190px}";
var _13 = "._18u0idpf{margin-left:0}";
var _12 = "._otyridpf{margin-bottom:0}";
var _11 = "._2hwxidpf{margin-right:0}";
var _10 = "._19pkidpf{margin-top:0}";
var _9 = "._1dyzt94y{letter-spacing:1px}";
var _8 = "._k48p1nn1{font-weight:400}";
var _7 = "._1wyb1skh{font-size:11px}";
var _6 = "._ect4k7ds{font-family:monospace}";
var _5 = "._1e0c1txw{display:flex}";
var _4 = "._syazryvq{color:rgba(205,214,244,.8)}";
var _3 = "._vchhusvi{box-sizing:border-box}";
var _2 = "._19itglyw{border:none}";
var _ = "._11q7izeb{background:var(--_1k9t07z)}";
var noop = function noop() {
  return undefined;
};
var ListItem = function ListItem(props) {
  var background = props.background ? props.background(props) : props.isSelected ? theme.main40 : "transparent";
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32]), /*#__PURE__*/React.createElement("div", {
    "data-test-id": "__prosemirror_devtools_list_item".concat(props.isDimmed ? "_inactive" : "", "__"),
    onClick: props.onClick,
    onDoubleClick: props.onDoubleClick,
    className: ax(["_11q7izeb _19itglyw _vchhusvi _syazryvq _1e0c1txw _ect4k7ds _1wyb1skh _k48p1nn1 _1dyzt94y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1ul913i4 _tzy4139p _ca0qi2wt _u5f3f6fq _n3tdi2wt _19bvf6fq _19bvnm8a _y3gn1e5h _1p1dangw _v5641y8x _1bsb1osq _w41414jc _irr31wye _30l35y2n _d0altlke _nt751r31 _49pcglyw _1hvw1o36 _1di61emw"]),
    style: {
      "--_1k9t07z": ix(background),
      "--_yl51qy": ix(props.isDimmed ? 0.3 : 1),
      "--_1hdy39e": ix(props.nested ? "36px" : "18px")
    }
  }, props.children));
};
function ListItemGroup(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    collapsed = _React$useState2[0],
    setCollapsed = _React$useState2[1];
  var items = props.items,
    _props$groupTitle = props.groupTitle,
    groupTitle = _props$groupTitle === void 0 ? noop : _props$groupTitle,
    title = props.title,
    _props$isSelected = props.isSelected,
    isSelected = _props$isSelected === void 0 ? noop : _props$isSelected,
    _props$isPrevious = props.isPrevious,
    isPrevious = _props$isPrevious === void 0 ? noop : _props$isPrevious,
    _props$isDimmed = props.isDimmed,
    isDimmed = _props$isDimmed === void 0 ? noop : _props$isDimmed,
    _props$getKey = props.getKey,
    getKey = _props$getKey === void 0 ? noop : _props$getKey,
    _props$onListItemClic = props.onListItemClick,
    onListItemClick = _props$onListItemClic === void 0 ? noop : _props$onListItemClic,
    _props$onListItemDoub = props.onListItemDoubleClick,
    onListItemDoubleClick = _props$onListItemDoub === void 0 ? noop : _props$onListItemDoub,
    customItemBackground = props.customItemBackground;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ListItem, {
    key: getKey(items[0]),
    onClick: function onClick() {
      return setCollapsed(!collapsed);
    },
    isSelected: items.some(isSelected) && collapsed,
    isPrevious: isPrevious(items[0], 0) && collapsed,
    isDimmed: items.every(isDimmed),
    background: customItemBackground
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }, groupTitle(items, 0)), /*#__PURE__*/React.createElement("div", null, collapsed ? "▶" : "▼")), /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_33]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_1e0crqpp"]),
    style: {
      "--_1a5yx7a": ix(collapsed ? "none" : "block")
    }
  }, (items || []).map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: getKey(item),
      nested: true,
      isSelected: isSelected(item, index),
      isPrevious: isPrevious(item, index),
      isDimmed: isDimmed(item, index),
      background: customItemBackground,
      onClick: function onClick() {
        return onListItemClick(item, index);
      },
      onDoubleClick: function onDoubleClick() {
        return onListItemDoubleClick(item, index);
      }
    }, title(item, index));
  }))));
}
export function List(props) {
  var _props$isSelected2 = props.isSelected,
    isSelected = _props$isSelected2 === void 0 ? noop : _props$isSelected2,
    _props$isPrevious2 = props.isPrevious,
    isPrevious = _props$isPrevious2 === void 0 ? noop : _props$isPrevious2,
    _props$isDimmed2 = props.isDimmed,
    isDimmed = _props$isDimmed2 === void 0 ? noop : _props$isDimmed2,
    _props$getKey2 = props.getKey,
    getKey = _props$getKey2 === void 0 ? noop : _props$getKey2,
    _props$onListItemClic2 = props.onListItemClick,
    onListItemClick = _props$onListItemClic2 === void 0 ? noop : _props$onListItemClic2,
    _props$onListItemDoub2 = props.onListItemDoubleClick,
    onListItemDoubleClick = _props$onListItemDoub2 === void 0 ? noop : _props$onListItemDoub2;
  return /*#__PURE__*/React.createElement("div", null, (props.items || []).map(function (item, index) {
    if (Array.isArray(item)) {
      return /*#__PURE__*/React.createElement(ListItemGroup, _extends({}, props, {
        items: item,
        key: item[0].timestamp
      }), (props.groupTitle || noop)(item, index));
    }
    return /*#__PURE__*/React.createElement(ListItem, {
      key: getKey(item),
      isSelected: isSelected(item, index),
      isPrevious: isPrevious(item, index),
      isDimmed: isDimmed(item, index),
      background: props.customItemBackground,
      onClick: function onClick() {
        return onListItemClick(item, index);
      },
      onDoubleClick: function onDoubleClick() {
        return onListItemDoubleClick(item, index);
      }
    }, props.title(item, index));
  }));
}